export default __webpack_public_path__ + "static/media/desktop_mac_active.446ba949.svg";